import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../common/constants';

const PromptTypes = types
  .model('PromptTypes', {
    status: types.maybeNull(types.string),
    data: types.maybeNull(types.array(types.string))
  })
  .actions((self) => ({
    fetchPromptTypes(payload) {
      Framework.getEventManager().publish(constants.GET_PROMPT_TYPES_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, {
        status: response.status || null, // Ensure status is a string or null
        data: Array.isArray(response.data) ? response.data : [] //
      });
      Framework.getEventManager().publish(constants.SET_PROMPT_TYPES_DATA);
    }
  }));

export default PromptTypes;
